export default "__VITE_ASSET__d22715ef__"